<!-- eslint-disable @angular-eslint/template/eqeqeq
 [formGroup]="attributeForm" -->
<ng-container *ngIf="isLoadingData">
  <nz-spin nzTip="Loading data..." [nzSize]="'large'"></nz-spin>
</ng-container>



<ng-container *ngIf="!isLoadingData">
<app-page-header
  *ngIf="this.record !== null"
  [submitButtonDisabled]="submitting"
  [showLanguage]="true"
  (languageChanged)="languageChanged($event)"
  [componentModel]="componentModel"
  (saveButtonClicked)="submit()">
</app-page-header>


<div [hidden]="submitting">
  <ng-container *ngIf="this.record !== null">
    
    <div class="container">
      <form nz-form [formGroup]="formGroup" (ngSubmit)="submit()">
        <div formGroupName="basicInfo" class="page-content-section">
          <fieldset>
            <legend>{{ "Product Basic Info" | locale }}</legend>
          </fieldset>
          <ng-container *ngFor="let item of basicProductProps">
            <app-bulk-edit-field 
              *ngIf="item.Code !== 'InheriteFrom'"
              [field]="item"
              [isBulkEdit]="true"
              [record]="record"
              [dropDownsMetaData]="dropDownData"
              [objectTypeId]="record.ObjectType"
              [formGroup]="BasicInfoGroup"
            ></app-bulk-edit-field>
            <ng-container
              *ngIf="item.Code === 'InheriteFrom'"
            ></ng-container>
          </ng-container>


          <form [formGroup]="attributeForm" class="attribute-select-form">
            <h3 class="dropdown-title">Select an attribute set</h3>
           
            <nz-form-item>
              <nz-form-control>
                <nz-select
                  nzPlaceHolder="Select an attribute set"
                  [(ngModel)]="selectedAttributeSetId"
                  (ngModelChange)="setId($event)"
                  formControlName="attributeSetId"
                 
                  class="styled-dropdown"
                >
                  <nz-option
                    *ngFor="let item of paginatedAttributSets"
                    [nzValue]="item.id"
                    [nzLabel]="item.name"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </form>
        </div>
     
        
       

        <app-custom-attributes
        [isBulkEdit]="true"
        [objectTypeId]="record.ObjectType"
        [record]="record"
        formGroupName="AttributeValues"
      >
      </app-custom-attributes>
      
      </form>
    </div>

    
  </ng-container>
</div>
</ng-container>



<div *ngIf="submitting && !completed" class="container page-content-section">
  <nz-result
    [nzIcon]="loadingIcon"
    [nzTitle]="
      'Your changes are being submitted please don\'t refresh the browser.'
    "
  >
    <ng-template #loadingIcon>
      <nz-spin [nzSize]="'large'"></nz-spin>
      <br />
      <br />
    </ng-template>
  </nz-result>
</div>
<div *ngIf="completed" class="container page-content-section">
  <nz-result
    [nzIcon]="'success'"
    [nzTitle]="'Your changes have been submitted successfully.'"
  >
  <div nz-result-extra>
    <button nz-button nzType="primary" (click)="goBack()">
      Back to Product
    </button>
  </div>
  </nz-result>

 
</div>




<!-- 
<ng-template #inheriteFromField>
  <div style="padding-inline: 2%">
    <p>Change Inherite From [Global]</p>
    <nz-row>
      <nz-form-control nz-col nzSpan="12">
        <p>From: <small>[optional]</small></p>
        <a
          (click)="ShowInheritenceProducts(true)"
          *ngIf="productInherite?.from == null"
        >
          Choose product
        </a>
        <span *ngIf="productInherite?.from != null">
          {{ productInherite.from!.name }} <br />
          {{ productInherite.from!.sku }}<br />
          <nz-space>
            <a
              *nzSpaceItem
              style="color: red"
              nz-popconfirm
              [nzPopconfirmTitle]="
                'Are you sure deleting inheritence?' | locale
              "
              (nzOnConfirm)="removeInheritence()"
            >
              Remove
            </a>
            <a *nzSpaceItem (click)="ShowInheritenceProducts(true)"> change </a>
          </nz-space>
        </span>
      </nz-form-control>
      <nz-form-control nz-col nzSpan="12">
        <p>To:</p>
        <a
          (click)="ShowInheritenceProducts(false)"
          *ngIf="productInherite?.to == null"
        >
          Choose product
        </a>
        <span *ngIf="productInherite?.to != null">
          {{ productInherite.to!.name }} <br />
          {{ productInherite.to!.sku }}<br />
          <nz-space>
            <a
              *nzSpaceItem
              style="color: red"
              nz-popconfirm
              [nzPopconfirmTitle]="
                'Are you sure deleting inheritence?' | locale
              "
              (nzOnConfirm)="removeInheritence()"
            >
              Remove
            </a>
            <a *nzSpaceItem (click)="ShowInheritenceProducts(false)">
              change
            </a>
          </nz-space>
        </span>
      </nz-form-control>
    </nz-row>
  </div>
</ng-template> -->
